import { Route } from '@angular/router';

export const subscriptionsOldRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'kaseya-365',
    data: { prefetchTarget: 'kaseya-365' },
  },
  {
    path: 'kaseya-365',
    loadComponent: () =>
      import('@pages/subscriptions-old/components/k365-subscriptions-tab/k365-subscriptions/k365-subscriptions.component').then(
        ({ K365SubscriptionsComponent }) => K365SubscriptionsComponent
      ),
  },
  {
    path: 'it-complete',
    loadComponent: () =>
      import('@pages/subscriptions-old/components/it-complete-subscriptions-tab/it-complete-subscriptions/it-complete-subscriptions.component').then(
        ({ ItCompleteSubscriptionsComponent }) => ItCompleteSubscriptionsComponent
      ),
  },
];
